export default __webpack_public_path__ + "static/media/Cocogoose-Bold.36e49957.ttf";